import BackButton from '../../../shared/back-button';

interface EditProfileProps {
  form: React.ReactNode;
  title: string;
}

export const EditProfile: React.FC<EditProfileProps> = (props) => {
  return (
    <div className="flex flex-col space-y-6">
      <BackButton title={props?.title} />
      {props.form}
    </div>
  );
};
